import { nowISO } from '@/lib/dates';
import type { Booking } from '@/types/domain';
import { provider } from './client';

export async function listBookings(clubId: string): Promise<Booking[]> {
  const bookings = await provider.listBookings(clubId);
  // Most recent slot first, oldest last.
  return bookings.sort((a, b) => (a.startAt < b.startAt ? 1 : -1));
}

export async function createBooking(
  input: Omit<Booking, 'id' | 'createdAt' | 'status' | 'createdBy'> & { status?: Booking['status'] },
): Promise<Booking> {
  const booking = await provider.createBooking({
    ...input,
    status: input.status ?? 'PENDING',
    createdAt: nowISO(),
    createdBy: null, // the provider records the real operator id (Supabase: created_by)
  });
  await provider.addActivity({
    clubId: input.clubId,
    type: 'BOOKING',
    message: `New booking by ${input.customerName}`,
    amountPaise: null,
    at: nowISO(),
  });
  return booking;
}

export async function setBookingStatus(
  id: string,
  status: Booking['status'],
): Promise<Booking> {
  return provider.updateBooking(id, { status });
}
